<app-background #background></app-background>
<div class="contenu" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)" [attr.aria-label]="'Double tap to navigate to next news'">
    <app-news #newsDisplayed class="newsToDisplay"></app-news>
</div>
<div class="footer">
    <app-playlist #playlist class="playList"></app-playlist>
    <app-qr-code #qrCode class="qrCode"></app-qr-code>
</div>
